import api from 'shared/api'

const FETCH_COMPANY_REQUEST = 'companyDirectorShares/FETCH_COMPANY_REQUEST'
const FETCH_COMPANY_SUCCESS = 'companyDirectorShares/FETCH_COMPANY_SUCCESS'
const FETCH_COMPANY_FAILURE = 'companyDirectorShares/FETCH_COMPANY_FAILURE'
const FETCH_DIRECTOR_REQUEST = 'companyDirectorShares/FETCH_DIRECTOR_REQUEST'
const FETCH_DIRECTOR_SUCCESS = 'companyDirectorShares/FETCH_DIRECTOR_SUCCESS'
const FETCH_DIRECTOR_FAILURE = 'companyDirectorShares/FETCH_DIRECTOR_FAILURE'

const initialState = {
  companyShares: [],
  loadedCompanyIds: [],
  companyLoading: false,
  directorShares: [],
  loadedDirectorIds: [],
  directorLoading: false,
  errors: []
}

export function fetchCompanyRequest(payload = {}) {
  return {
    type: FETCH_COMPANY_REQUEST,
    loadedCompanyIds: payload.loadedCompanyIds,
  }
}

export function fetchCompanySuccess(payload) {
  return {
    type: FETCH_COMPANY_SUCCESS,
    payload,
  }
}

export function fetchCompanyFailure(errors = []) {
  return {
    type: FETCH_COMPANY_FAILURE,
    errors,
  }
}

export function fetchDirectorRequest(payload = {}) {
  return {
    type: FETCH_DIRECTOR_REQUEST,
    loadedDirectorIds: payload.loadedDirectorIds,
  }
}

export function fetchDirectorSuccess(payload) {
  return {
    type: FETCH_DIRECTOR_SUCCESS,
    payload,
  }
}

export function fetchDirectorFailure(errors = []) {
  return {
    type: FETCH_DIRECTOR_FAILURE,
    errors,
  }
}

export function loadCompanyShares(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedCompanyIds = state.companyDirectorShares.loadedCompanyIds ? state.companyDirectorShares.loadedCompanyIds.slice() : []
    if (!loadedCompanyIds.includes(id)) {
      loadedCompanyIds.push(id)
    }

    dispatch(fetchCompanyRequest({ loadedCompanyIds }))

    return api(`api/v1/companies/${id}/shares`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchCompanySuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchCompanyFailure(errors))
        })
      })
  }
}

export function loadDirectorShares(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedDirectorIds = state.companyDirectorShares.loadedDirectorIds ? state.companyDirectorShares.loadedDirectorIds.slice() : []

    if (!loadedDirectorIds.includes(id)) {
      loadedDirectorIds.push(id)
    }
    dispatch(fetchDirectorRequest({ loadedDirectorIds }))

    return api(`api/v1/directors/${id}/shares`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchDirectorSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchDirectorFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_COMPANY_REQUEST:
      return Object.assign({}, state, {
        companyLoading: true,
        loadedCompanyIds: action.loadedCompanyIds || state.loadedCompanyIds,
      })
    case FETCH_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        companyLoading: false,
        companyShares: [
          ...state.companyShares,
          payload
        ],
        errors: [],
      })
    case FETCH_COMPANY_FAILURE:
      return Object.assign({}, state, {
        companyLoading: false,
        errors,
      })
    case FETCH_DIRECTOR_REQUEST:
      return Object.assign({}, state, {
        directorLoading: true,
        loadedDirectorIds: action.loadedDirectorIds || state.loadedDirectorIds,
      })
    case FETCH_DIRECTOR_SUCCESS:
      return Object.assign({}, state, {
        directorLoading: false,
        directorShares: [
          ...state.directorShares,
          payload
        ],
        errors: [],
      })
    case FETCH_DIRECTOR_FAILURE:
      return Object.assign({}, state, {
        directorLoading: false,
        errors,
      })
    default:
      return state
  }
}

